function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommunityService = function SvgCommunityService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 70 70"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M70 35c0 19.3-15.7 35-35 35S0 54.3 0 35 15.7 0 35 0s35 15.7 35 35",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5d2fb0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3 33.4c.5.5 1.2.5 1.7 0l7-7.4c2.1-2.2 1.9-5.7-.4-7.7-2-1.7-5-1.4-6.8.5l-.7.8-.7-.8c-1.8-1.9-4.8-2.2-6.8-.5-2.3 2-2.4 5.6-.4 7.7zm18.8 5.1c-.8-.7-2-.7-2.8 0l-6 4.8c-.7.6-1.7.9-2.6.9H34c-.6 0-1-.5-1-1 0-.6.5-1 1-1h5.1c1 0 2-.7 2.2-1.7.2-1.3-.8-2.4-2.1-2.4H28.8c-1.8 0-3.5.6-4.8 1.7l-3 2.5h-3.6c-.6 0-1 .5-1 1v6.3c0 .6.5 1 1 1h23.2c.9 0 1.9-.3 2.6-.9l9.8-7.9c1-.9 1.1-2.5.1-3.3",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgCommunityService;